var _path, _path2, _rect, _rect2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.38,27.52h8.69V6.68H.53V27.52H9.21a3.86,3.86,0,0,0-1.31,2.9,3.9,3.9,0,1,0,6.48-2.9Zm-12.85-1V7.68H22.07V26.52Zm10.27,6.8a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,11.8,33.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,26.52a3.9,3.9,0,1,0,3.9,3.9A3.91,3.91,0,0,0,30.5,26.52Zm0,6.8a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,30.5,33.32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 28.81,
    width: 6.55,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.44,
    y: 28.81,
    width: 8.96,
    height: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.49,18.43c-.78-4.72-1.74-7.21-2.76-7.21H31.27l-1.13-1.14H23.77v15.5l2.67,1.85.57-.82-2.24-1.56v-14h5l1.13,1.14h5.76c.19.17,1,1.19,1.88,6.3V29.71c0,.18-.06.77-.63.77H35v1h2.88a1.67,1.67,0,0,0,1.63-1.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,21.2c0-7-1.19-7-1.58-7H30V21.7h7.5ZM31,20.7V15.21h4.83c.34.45.63,2.85.67,5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTooltip);
export default __webpack_public_path__ + "static/media/truck_tooltip.b135cf78338ae918f9d23e2e33f2142e.svg";
export { ForwardRef as ReactComponent };